































































import AffinityDisplay from "@/components/AffinityDisplay.vue";
import EmptyCell from "@/components/EmptyCell.vue";
import Vue from "vue";
export default Vue.extend({
  components: { AffinityDisplay, EmptyCell },
  props: ["item", "list_type"],
});
